'use strict';

var Quiz = require("./Quiz.bs.js");

function make(quiz, links) {
  return {
          quiz: quiz,
          links: links
        };
}

function makeData(json) {
  return {
          quiz: Quiz.makeArray(json.quiz),
          links: json.links
        };
}

function quiz(t) {
  return t.quiz;
}

exports.make = make;
exports.makeData = makeData;
exports.quiz = quiz;
/* No side effect */
